<span class="badge rounded-pill"><ng-content></ng-content></span>
